import {
  StandardEditResponseModel,
  StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { ProductCategoryModel } from "../redux/reducers/static-data.reducers";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getProductCategories(
  filter: any,
  limit?: number,
  page?: number,
): Promise<StandardResponseModel<ProductCategoryModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(
        `${API_URL}/product-categories`,
        { filter },
        { params, ...authorizationHeader },
      )
      .then((response) => {
        return response?.data as StandardResponseModel<ProductCategoryModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function createProductCategory(
  data: ProductCategoryModel,
): Promise<StandardResponseModel<ProductCategoryModel>> {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .post(`${API_URL}/product-category/create`, data, authorizationHeader)
      .then((response) => {
        return response?.data as StandardResponseModel<ProductCategoryModel>;
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

async function editProductCategory(
  categoryId: number,
  updateData: ProductCategoryModel,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/product-category/${categoryId}`,
        {
          ...updateData,
          productCategoryId: undefined,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as StandardEditResponseModel);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function deleteProductCategoryById(productCategoryId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/product-categories/${productCategoryId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getProductCategories,
  editProductCategory,
  createProductCategory,
  deleteProductCategoryById,
};
